enum NylasFormActivitySelection {
  ALL = "all",
  SPECIFIC = "specific",
}

export default NylasFormActivitySelection;
